import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "./theme";
import SignPage from "./components/SignPage";

function App() {
    return (
        <ThemeProvider theme={createTheme({ direction: "ltr" })}>
            <SignPage />
        </ThemeProvider>
    );
}

export default App;
